import { useEffect } from "react";
import { ReactComponent as Success } from "./assets/successNotification.svg";
import { ReactComponent as Error } from "./assets/errorNotification.svg";
import { ReactComponent as Message } from "./assets/messageNotification.svg";
import { useDispatch, useSelector } from "react-redux";

const NotificationIcon = ({ type }) => {
  switch (type) {
    case "success":
      return <Success />;
    case "error":
      return <Error />;
    default:
      return <Message />;
  }
};

const NotificationCenter = () => {
  const { notifications } = useSelector((state) => state.notifications);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    const filteredNotifications = notifications.filter(
      (notification) => !notification.hidden
    );

    if (filteredNotifications.length > 0) {
      setTimeout(() => {
        const updatedNotifications = notifications.map((notification) => {
          return { ...notification, hidden: true };
        });
        dispatch({ type: "set_notifications", payload: updatedNotifications });
      }, 3000);
    }
  }, [state]);

  return (
    <div>
      {notifications.map((notification, index) => {
        return (
          <div
            key={index}
            className="sb-notification-ctn"
            data-active={notification.hidden ? "hidden" : "shown"}
            data-notificationtype={notification.type}
          >
            <div className="sb-notification-icon">
              <NotificationIcon type={notification.type} />
            </div>
            <span className="sb-notification-text">{notification.content}</span>
          </div>
        );
      })}
    </div>
  );
};
export default NotificationCenter;
